

/**
 * 类型百分比通用组件
 */

import { useEffect } from 'react';
import { Chart } from '@antv/g2';
import CNF from '../incs/Config.js';

const RTypePercent = (props) => {

    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id',
            autoFit: true,
        });

        chart.title({
            title: props.title,
            subtitle: props.subtitle,
        });

        chart.data(props.data);
        chart.coordinate({ type: 'theta', outerRadius: 0.8 });
        chart
            .interval()
            .transform({ type: 'stackY' })
            .encode('y', 'percent')
            .encode('color', 'type')
            .legend('color', { position: 'top', layout: { justifyContent: 'left' } })
            .animate('enter', {
                type: 'waveIn',
                duration: CNF.animateDuration,
            })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .label({
                position: 'spider',
                text: (data) => `${data.type}: ${data.percent}%`,
            })
            .style('radius', 6)
            .style('stroke', '#fff')
            .style('lineWidth', 2)
            .tooltip((data) => ({
                name: data.type,
                value: `${data.percent}%`,
            }))
            .tooltip((data) => ({
                name: '数量',
                value: `${data.count}`,
            }));
        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props]);

    return <div id='antv-g2-id'></div>
}

export default RTypePercent;